export default function styles(theme) {
  return {
    driver: {
      display: 'flex',
    },
    label: {
      marginLeft: '0.5rem',
      textTransform: 'capitalize',
    },
    preferred: {
      marginLeft: '0.2rem',
    },
    iconButton: {
      width: 25,
      height: 25,
      borderRadius: 5,
      marginRight: '0.3rem',
      border: `1px solid ${theme.color.black}`,
      background: 'transparent',
      transition: 'all 0.2s ease',
      '&:hover': {
        background: theme.color.black,
        borderColor: theme.color.black,

        '& $iconRoute': {
          color: theme.color.white,
        },
      },
    },
    iconButtonDisabled: {
      width: 25,
      height: 25,
      borderRadius: 5,
      marginRight: '0.3rem',
      border: '1px solid rgba(0, 0, 0, 0.26)',
    },
    iconRoute: {
      fontSize: '1rem',
      color: theme.color.black,
    },
    iconRouteDisabled: {
      fontSize: '1rem',
    },
  }
}
